<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { AcfFlexItem, PageBlock } from '@/utils/components'

const props = defineProps<{
  block?: PageBlock
  data?: AcfFlexItem | PageBlock
}>()

const { t } = useI18n()

function getDataLayout(value: AcfFlexItem | PageBlock | undefined) {
  if (!value) return undefined
  if ('type' in value && typeof value.type === 'string') return value.type
  if ('acf_fc_layout' in value && typeof value.acf_fc_layout === 'string') return value.acf_fc_layout
  return undefined
}

const blockType = computed(() => props.block?.type ?? getDataLayout(props.data))
</script>

<template>
  <div class="p-4 m-2 border border-dashed rounded-lg">
    <div class="text-sm font-medium">{{ t('missingComponent.loading') }}</div>
    <div class="text-xs opacity-70">
      block type: <code>{{ blockType }}</code>
    </div>
  </div>
</template>
